module.exports = __webpack_public_path__ + "img/richardward.4720b6fd.jpg";